<div class="menu-settings-tlhex position-relative">

	<!--LEFT MENU COMPONENTS-->
	@if (stateDescription?.isWorkflowRunning == workflowEnum.none) { <tools-menu /> }

	@if (isMechAxisWorkflow) { <mechanical-axis /> }

	@if (stateDescription?.isWorkflowRunning == workflowEnum.boneTypeSelection) { <bone-type-selection /> }

	@if (stateDescription?.isWorkflowRunning == workflowEnum.rotate) { <rotation-workflow /> }

	@if (stateDescription?.isWorkflowRunning == workflowEnum.crop) { <cropping-workflow /> }

	@if (stateDescription?.isWorkflowRunning == workflowEnum.insertOsteotomy) { <osteotomy-workflow /> }

	@if (stateDescription?.isWorkflowRunning == workflowEnum.insertPlate) { <template-selection /> }

	<!--RIGHT MENU - DRAWER-->
	<drawer />

</div>